export default {
        //apiKey: '7f037fcc-21f0-4c1b-ad6e-1f292ef45a2f&suggest_apikey=83399f94-6cb6-45fa-9fba-6ad4a37625a0',
        apiKey: '178e0c56-84e3-4c99-8c51-608be8c52fcd&suggest_apikey=83399f94-6cb6-45fa-9fba-6ad4a37625a0',
        suggestApiKey: '',
        lang: 'ru_RU',
        coordorder: 'latlong',
        version: '2.1'
    };
